import React from 'react';

import { ICL, TaskKeysType, TextTask, WorkType } from '../../../shared/types';
import StudentTaskWrapper from '../StudentTaskWrapper';

interface StudentTextTaskProps extends TextTask {
  icl: ICL | null;
  handleChangeTaskByKey: (id: string, key: TaskKeysType, value: string | string[] | boolean) => void;
  saveTaskAnswer: (id: string) => Promise<void>;
  hw?: boolean;
  preview?: boolean;
  studentName: string;
  index: number;
  points: number;
  workTaskType?: WorkType;
}

export default function StudentTextTask({
  icl,
  text,
  subText,
  answer,
  hasAnswer,
  hasStar,
  checkedAt,
  completedAt,
  handleChangeTaskByKey,
  id,
  hasPhoto,
  answersPhotos,
  saveTaskAnswer,
  deadline,
  audioUrl,
  videoUrl,
  taskPhotos,
  editedAnswerPhotos,
  hw,
  pdfUrl,
  wordUrl,
  studentPdfUrl,
  studentWordUrl,
  preview,
  studentName,
  index,
  points,
  workTaskType,
  teacherPoints,
}: StudentTextTaskProps) {
  return (
    <StudentTaskWrapper
      studentName={studentName}
      icl={icl}
      taskText={text}
      subText={subText}
      answersPhotos={answersPhotos}
      id={id}
      handleChangeTaskByKey={handleChangeTaskByKey}
      checkedAt={checkedAt}
      hasPhoto={hasPhoto}
      completedAt={completedAt}
      saveTaskAnswer={saveTaskAnswer}
      deadline={deadline}
      audioUrl={audioUrl}
      answer={answer}
      hasAnswer={hasAnswer}
      hasStar={hasStar}
      videoUrl={videoUrl}
      taskPhotos={taskPhotos}
      editedAnswerPhotos={editedAnswerPhotos}
      hw={hw}
      pdfUrl={pdfUrl}
      wordUrl={wordUrl}
      studentPdfUrl={studentPdfUrl}
      studentWordUrl={studentWordUrl}
      preview={preview}
      index={index}
      points={points}
      workTaskType={workTaskType}
      teacherPoints={teacherPoints}
    >
      <></>
    </StudentTaskWrapper>
  );
}
